export default __webpack_public_path__ + "static/media/completed.ee649779.png";